import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xxl-stretch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder text-white" }, "Investor Statistics", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = { class: "card-p mt-n20 position-relative" }
const _hoisted_6 = { class: "row m-0" }
const _hoisted_7 = { class: "col-md col-12 bg-light-warning px-6 py-8 rounded-2 me-7 mb-7" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-9" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "pt-lg-5 mt-xl-2 mt-0 pt-md-3",
    style: {"color":"rgb(207, 187, 88)","font-size":"15px"}
  }, " Businesses Reviewed ")
], -1)
const _hoisted_10 = {
  class: "col-3 display-2 text-center",
  style: {"color":"rgb(226, 213, 147)"}
}
const _hoisted_11 = { class: "col-md col-12 bg-light-primary px-6 py-8 rounded-2 mb-7" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-9" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "pt-lg-5 mt-xl-2 mt-0 pt-md-3",
    style: {"color":"#9bbfd3","font-size":"15px"}
  }, " Virtual Pitch Requests ")
], -1)
const _hoisted_14 = {
  class: "col-3 display-2 text-center",
  style: {"color":"#9bbfd3"}
}
const _hoisted_15 = { class: "row m-0 mb-xl-5 pb-2 mb-0" }
const _hoisted_16 = { class: "col-md col-12 bg-light-danger px-6 py-8 rounded-2" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-9" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "pt-lg-5 mt-xl-2 mt-0 pt-md-3",
    style: {"color":"#e2adbc","font-size":"15px"}
  }, " Declined ")
], -1)
const _hoisted_19 = {
  class: "col-3 display-2 text-center",
  style: {"color":"#e2adbc"}
}
const _hoisted_20 = { class: "col-md col-12 bg-light-success px-6 py-8 rounded-2 ms-md-7 mt-md-0 mt-7" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-9" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "pt-lg-5 mt-xl-2 mt-0 pt-md-3",
    style: {"color":"#9ae6c0","font-size":"15px"}
  }, " Investments ")
], -1)
const _hoisted_23 = {
  class: "col-3 display-2 text-center",
  style: {"color":"#9ae6c0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([`bg-${_ctx.widgetColor}`, "card-header border-0 py-5"])
    }, _hoisted_3, 2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.user?.investorBusinessReviewed ?? 0), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.user?.investorPitchRequestsCount ?? 0), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.user?.investorDeclinedBusiness ?? 0), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.user?.investorInvestments ?? 0), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}